import React, { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import { Plus, User, Tag, RefreshCw } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import TabButton from '../components/enseignant/TabButton';
import EnseignantTab from '../components/enseignant/EnseignantTab';
import StatutTab from '../components/enseignant/StatutTab';

const EnseignantPage = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('enseignants');
  // Separate trigger states for each tab
  const [triggerEnseignantAdd, setTriggerEnseignantAdd] = useState(0);
  const [triggerStatutAdd, setTriggerStatutAdd] = useState(0);
  const [triggerRefresh, setTriggerRefresh] = useState(0);

  // Récupérer l'onglet actif du localStorage au montage
  useEffect(() => {
    const savedTab = localStorage.getItem('enseignantActiveTab');
    if (savedTab) {
      setActiveTab(savedTab);
    }
  }, []);

  // Mettre à jour le localStorage quand l'onglet actif change
  useEffect(() => {
    localStorage.setItem('enseignantActiveTab', activeTab);
  }, [activeTab]);

  const handleAddNew = () => {
    if (activeTab === 'enseignants') {
      setTriggerEnseignantAdd(prev => prev + 1);
    } else {
      setTriggerStatutAdd(prev => prev + 1);
    }
  };

  const handleRefresh = () => {
    // Déclencher le rafraîchissement de l'onglet actif
    setTriggerRefresh(prev => prev + 1);
  };

  return (
    <Layout>
      <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-8">
          {/* Card principale avec design professionnel */}
          <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
            {/* Header avec bannière bleue */}
            <div className="bg-gradient-to-r from-[#202654] to-[#202654]/90 px-6 py-8">
              <div className="flex flex-col md:flex-row md:items-center md:justify-between">
                <div className="flex items-center text-white">
                  <button
                    onClick={() => navigate(-1)}
                    className="mr-4 p-2 rounded-lg bg-white/10 hover:bg-white/20 transition-all duration-200 backdrop-blur-sm"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
          <div>
                    <h1 className="text-2xl font-bold">Gestion des Enseignants</h1>
                    <p className="mt-1 text-blue-100">
              Gérez les enseignants et leurs statuts
            </p>
          </div>
                </div>
                <div className="mt-4 md:mt-0 flex flex-col sm:flex-row sm:space-x-3 space-y-3 sm:space-y-0">
                  <button
                    onClick={handleRefresh}
                    className="inline-flex items-center justify-center px-4 py-2 border border-white/20 rounded-md shadow-sm text-sm font-medium text-white bg-white/10 hover:bg-white/20 backdrop-blur-sm transition-all duration-200"
                  >
                    <RefreshCw className="h-4 w-4 mr-2" />
                    Actualiser
                  </button>
          <button
            onClick={handleAddNew}
                    className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-white/10 hover:bg-white/20 backdrop-blur-sm transition-all duration-200"
          >
            <Plus className="h-5 w-5 mr-2" />
            {activeTab === 'enseignants' 
              ? 'Nouvel Enseignant' 
              : 'Nouveau Statut'
            }
          </button>
                </div>
              </div>
        </div>

            {/* Onglets intégrés dans le design */}
            <div className="border-b border-gray-200 bg-white">
          <nav className="flex">
            <TabButton
              isActive={activeTab === 'enseignants'}
              onClick={() => setActiveTab('enseignants')}
              icon={User}
            >
              Enseignants
            </TabButton>
            <TabButton
              isActive={activeTab === 'statuts'}
              onClick={() => setActiveTab('statuts')}
              icon={Tag}
            >
              Statuts
            </TabButton>
          </nav>
        </div>

        {/* Contenu de l'onglet actif */}
            <div className="p-6">
              <div style={{ display: activeTab === 'enseignants' ? 'block' : 'none' }}>
                <EnseignantTab 
                  triggerAdd={triggerEnseignantAdd} 
                  triggerRefresh={triggerRefresh}
                />
              </div>
              <div style={{ display: activeTab === 'statuts' ? 'block' : 'none' }}>
                <StatutTab 
                  triggerAdd={triggerStatutAdd}
                  triggerRefresh={triggerRefresh}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default EnseignantPage;
